const handleAnnoucementBar = (() => {
  const root = document.querySelector(".announcement-bar");

  if (root) {
    document.body.classList.add("has-announcement-bar");
  }
})();

if (!document.body.classList.contains("password")) {
  var mobile_menu = jQuery(function () {
    var btn = jQuery("nav .mobile-nav-btn");
    var nav_wrapper = jQuery("#mobile-subnav-wrapper");
    var open = false;
    var initd = false;
    var nav_page_1 = null;
    var nav_page_2 = null;
    var nav_page_2_title = null;

    function animateMenu(left, opacity) {
      nav_wrapper.show().animate(
        {
          left: left,
          opacity: opacity,
        },
        500,
        function () {
          if (opacity == 0) {
            nav_wrapper.hide();
          }
        }
      );
    }

    function setup_li(jq_this) {
      var child_nav = jq_this.children("ul");

      var new_parent = jQuery('<div class="secondary-level"></div>');

      new_parent.append(child_nav);

      nav_page_2.append(new_parent);

      var child_a = jq_this.children("a");

      child_a.click(function () {
        show_secondary_nav(new_parent, child_a.text());
        return false;
      });
    }

    function init() {
      if (initd) {
        return;
      }
      initd = true;
      nav_page_1 = jQuery(".mobile-nav-page-1");
      nav_page_2 = jQuery(".mobile-nav-page-2");
      nav_page_2_title = jQuery(".mobile-nav-page-2-title");

      //move secondary level navs into own container in .mobile-nav-page-2
      jQuery(".other-nav-items > ul > li.menu-item-has-children").each(
        function () {
          setup_li(jQuery(this));
        }
      );

      var more_menu = jQuery("<div></div>");
      var more_menu_ul = jQuery("<ul></ul>");
      more_menu.append(more_menu_ul);

      var main_menu_items = jQuery(".other-nav-items > ul  li");
      // the initial value of i determines which menu items appear under more
      for (var i = 3; i < main_menu_items.length; i++) {
        more_menu_ul.append(main_menu_items[i]);
      }

      nav_page_2.append(more_menu);

      var btn_more = jQuery('<div class="btn-more">More</div>');
      jQuery(".other-nav-items").append(btn_more);
      btn_more.click(function () {
        show_secondary_nav(more_menu, "");
      });

      jQuery(".nav-back").click(function () {
        hide_secondary_nav();
      });
    }

    function show_secondary_nav(nav, title) {
      nav_page_2.css({
        "margin-left": "100%",
        display: "block",
      });
      nav_page_1.animate(
        {
          "margin-left": "-100%",
        },
        500
      );
      nav_page_2.animate(
        {
          "margin-left": "0%",
        },
        500
      );

      //hide all menus and nav title
      nav_page_2.children().hide();
      nav.show();

      if (title.length > 0) {
        nav_page_2_title.show().html(title);
      }
    }
    function hide_secondary_nav() {
      nav_page_1.animate(
        {
          "margin-left": "0%",
        },
        500
      );
      nav_page_2.animate(
        {
          "margin-left": "100%",
        },
        500
      );
    }

    btn.click(function () {
      init();

      open = !open;
      if (open) {
        jQuery("body").css("overflow", "hidden");
        btn.addClass("open");
        nav_page_1.attr("style", "");
        nav_page_2.attr("style", "");
        animateMenu("-30vw", 1);
      } else {
        btn.removeClass("open");
        animateMenu("100vw", 0);
        jQuery("body").css("overflow", "");
      }
    });
  });
}

var navFunctions = {
  isNavOpen: false,
  subnavList: [],
  activeSection: [true, true, true],

  init: function () {
    this.subnavList.push(jQuery("#subnav-wrapper .products"));
    this.subnavList.push(jQuery("#subnav-wrapper .about-fairlife"));
    this.subnavList.push(jQuery("#subnav-wrapper .community"));
    var me = this;
    jQuery("#navigation li a").click(function () {
      return me.handleClick(this);
    });

    jQuery(".brands li a").hover(
      function () {
        var brand_name = jQuery(this).parent().attr("class");
        if (brand_name && brand_name.length > 0) {
          jQuery(".bottles li").hide();
          jQuery(".bottles ." + brand_name).show();
        }
      },
      function () {}
    );

    (function () {
      var open_nav = false;
      jQuery(
        "#subnav-wrapper .about-fairlife .subnav > li.menu-item-has-children"
      ).each(function () {
        var li = jQuery(this);
        li.hover(
          function () {
            if (!li.hasClass("open")) {
              if (open_nav) {
                open_nav.removeClass("open");
                open_nav.children("ul").hide();
              }
              li.addClass("open");
              li.children("ul").show();
              open_nav = li;
            }
          },
          function () {}
        );
      });
      jQuery(
        "#subnav-wrapper .about-fairlife .subnav > li:not(.menu-item-has-children)"
      ).each(function () {
        var li = jQuery(this);
        li.hover(
          function () {
            if (open_nav) {
              open_nav.removeClass("open");
              open_nav.children("ul").hide();
              open_nav = false;
            }
          },
          function () {}
        );
      });
    })();

    jQuery("#primary-nav").click(function (ev) {
      ev.stopPropagation();
    });
    jQuery("body").click(function () {
      if (me.isNavOpen) {
        me.slideUpSubnav();
      }
    });
  },

  handleClick: function (that) {
    var navTab = jQuery(that);

    if (navTab.attr("href") == "#products") {
      this.clickResponse(this.subnavList[0]);
      return false;
    } else if (navTab.attr("href") == "#about") {
      this.clickResponse(this.subnavList[1]);
      return false;
    } else if (navTab.attr("href") == "#community") {
      this.clickResponse(this.subnavList[2]);
      return false;
    }

    return true;
  },

  //Refactor to only work when open nav tab is clicked a second time
  clickResponse: function (subnavSection) {
    var actvIndex;
    for (var i = 0; i < this.subnavList.length; i++) {
      if (this.subnavList[i] != subnavSection && this.activeSection[i]) {
        this.subnavList[i].addClass("hide");
        this.activeSection[i] = false;
      } else if (this.subnavList[i] == subnavSection) {
        actvIndex = i;
      }
    }
    if (!this.activeSection[actvIndex]) {
      subnavSection.removeClass("hide");
      this.activeSection[actvIndex] = true;
      if (!this.isNavOpen) {
        this.slideDownSubnav();
      }
    } else if (!this.isNavOpen) {
      this.slideDownSubnav();
    } else if (this.activeSection[actvIndex]) {
      this.slideUpSubnav();
    }
  },

  slideDownSubnav: function () {
    var subnavWrapper = jQuery("#subnav-wrapper");
    subnavWrapper.slideDown("slow");
    this.isNavOpen = true;
  },

  slideUpSubnav: function () {
    var subnavWrapper = jQuery("#subnav-wrapper");
    subnavWrapper.slideUp("slow");
    this.isNavOpen = false;
  },
};

if (!document.body.classList.contains("password")) {
  navFunctions.init();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.activeIndex = 1;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    if (this.prevButton) {
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = this.calculateCurrentPage();

    this.updatePaginationDisplay();
    this.dispatchSlideChangedEvent(previousPage);

    if (!this.enableSliderLooping) {
      this.updateNavigationButtons();
    }
  }

  calculateCurrentPage() {
    return Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  }

  updatePaginationDisplay() {
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages; // Removed `- 1` to ensure correct display
    }
  }

  dispatchSlideChangedEvent(previousPage) {
    if (
      this.currentPage !== previousPage &&
      this.sliderItemsToShow[this.currentPage - 1]
    ) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
  }

  updateNavigationButtons() {
    const firstSlideVisible =
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0;
    const lastSlideVisible = this.isSlideVisible(
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
    );

    this.prevButton.toggleAttribute("disabled", firstSlideVisible);
    this.nextButton.toggleAttribute("disabled", lastSlideVisible);
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = parseInt(event.currentTarget.dataset.step) || 1;

    // if (event.currentTarget.classList.contains("navigation-button")) {
    //   const thumbnails = this.nextElementSibling.children[1].children;
    //   this.activeIndex += step;

    //   if (this.activeIndex > thumbnails.length) {
    //     this.activeIndex = 1;
    //   } else if (this.activeIndex < 1) {
    //     this.activeIndex = thumbnails.length;
    //   }

    //   thumbnails[this.activeIndex - 1].firstElementChild.click();
    // } else {
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
    // }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// class ProductRecommendations extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);

//       fetch(this.dataset.url)
//         .then((response) => response.text())
//         .then((text) => {
//           const html = document.createElement("div");
//           html.innerHTML = text;
//           const recommendations = html.querySelector("product-recommendations");

//           if (recommendations && recommendations.innerHTML.trim().length) {
//             this.innerHTML = recommendations.innerHTML;
//           }

//           if (
//             !this.querySelector("slideshow-component") &&
//             this.classList.contains("complementary-products")
//           ) {
//             this.remove();
//           }

//           if (html.querySelector(".grid__item")) {
//             this.classList.add("product-recommendations--loaded");
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         });
//     };

//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }

// customElements.define("product-recommendations", ProductRecommendations);

// const handleCardProductQuickView = (() => {
//   const modal = document.querySelector(".modal");
//   if (!modal) return;

//   const cards = Array.from(document.querySelectorAll(".product-card-wrapper"));
//   const close = modal.querySelector(".close");
//   const detailsLink = modal.querySelector(".details-link");

//   document.body.addEventListener("click", ({ target }) => {
//     if (!modal.children[1].contains(target)) {
//       modal.classList.remove("show");
//     }
//   });

//   close.addEventListener("click", () => {
//     modal.classList.remove("show");
//   });

//   cards.forEach((p) => {
//     p.addEventListener("click", (e) => {
//       console.log(e.target.classList.contains("quick-add__submit"));

//       const link = p.querySelector(".full-unstyled-link");

//       const getSectionID = () => {
//         request.open("GET", link.href, true);
//         request.send();
//       };

//       function handleResponse() {
//         const fakeDOM = document.createElement("html");
//         fakeDOM.innerHTML = this.responseText;

//         const mainContent = fakeDOM.querySelector("#MainContent");

//         if (mainContent) {
//           modal.classList.add("show");
//           modal.children[1].children[0].innerHTML =
//             mainContent.children[0].innerHTML;
//           detailsLink.href = link.href;
//         }
//       }

//       const request = new XMLHttpRequest();
//       request.addEventListener("load", handleResponse);

//       if (e.target.classList.contains("quick-add__submit")) {
//         setTimeout(() => {
//           window.location.href = 'https://fairlife-store.myshopify.com/cart'
//         }, 350)
//       } else {
//         e.preventDefault();
//         getSectionID();
//       }
//     });
//   });
// })();

const handleAddToCartButtonAnimation = (() => {
  const buttons = Array.from(document.querySelectorAll(".add-to-cart-button"));

  buttons.forEach((button) => {
    const success = button.parentElement.querySelector(".add-to-cart-success");

    const closeSuccess = button.parentElement.querySelector(
      ".add-to-cart-success .close"
    );

    const closeSuccessX = button.parentElement.querySelector(
      ".add-to-cart-success .times"
    );

    button.addEventListener("click", (e) => {
      button.classList.add("added");
      button.children[0].innerText = button.classList.contains("added")
        ? "Added To Cart!"
        : "Add To Cart";

      success.classList.add("show");

      setTimeout(() => {
        jQuery.ajax({
          type: "GET",
          url: window.Shopify.routes.root + "cart.js",
          dataType: "json",
          success: function (response) {
            window.SLIDECART_UPDATE();
            window.SLIDECART_OPEN();

            // const cartCounts = Array.from(
            //   document.querySelectorAll(".cart-count")
            // );
            // cartCounts.forEach((el) => {
            //   el.innerText = `Cart (${response.item_count})`;
            // });
          },
        });
      }, 1000);
    });

    const closeSuccessFunction = (e) => {
      e.preventDefault();

      button.children[0].innerText = button.classList.contains("added")
        ? "Add To Cart"
        : "Added To Cart!";

      button.classList.remove("added");
      success.classList.remove("show");
    };

    if (closeSuccess) {
      closeSuccess.addEventListener("click", closeSuccessFunction);
    }
    if (closeSuccessX) {
      closeSuccessX.addEventListener("click", closeSuccessFunction);
    }
  });
})();

const FLDhandleAddToCart = (() => {
  const buttons = Array.from(document.querySelectorAll(".add-to-cart-button"));

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      data = {
        items: [
          {
            id: parseInt(button.dataset.product),
            quantity: 1,
          },
        ],
      };

      gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-11500802/fairl005/fairl0+standard",
      });

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          window.SLIDECART_UPDATE();

          if (window.location.pathname === "/cart") {
            window.location.reload();
          }
        },
      });
    });
  });
})();

const handleMainProductDescription = (() => {
  const root = document.querySelector(".product__description");

  if (!root) return;

  const pTags = Array.from(
    root.querySelectorAll(".product .product__description p")
  );

  if (pTags.length > 2) {
    pTags.slice(2).forEach((p) => {
      p.style.display = "none";
    });

    root.insertAdjacentHTML(
      "beforeend",
      '<a href="#" class="read-more">Read More...</a>'
    );

    const readMore = document.querySelector(".read-more");

    if (readMore) {
      readMore.addEventListener("click", (e) => {
        e.preventDefault();
        pTags.forEach((p) => (p.style.display = "block"));
        readMore.style.display = "none";
      });
    }
  }
})();

const handleQuantityChangeAnimation = (() => {
  const buttons = Array.from(document.querySelectorAll(".quantity__button"));
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      button.classList.add("click");
      setTimeout(() => {
        button.classList.remove("click");
      }, 100);
    });
  });
})();

// const handleThumbnailSliderHover = (() => {
//   const roots = Array.from(document.querySelectorAll('.thumbnail-slider'));

//   roots.forEach(root => {
//     const thumbnails = Array.from(root.querySelectorAll('li'));
//     const mainImages = Array.from(root.previousElementSibling.querySelectorAll('.product__media-list li img'));

//     mainImages.forEach(main => {
//       main.dataset.og = main.src
//     })

//     thumbnails.forEach(thumbnail => {
//       thumbnail.addEventListener('mouseenter', () => {
//         thumbnail.firstElementChild.click()
//       })

//       thumbnail.addEventListener('mouseleave', () => {
//         const activeImage = root.previousElementSibling.querySelector('li.is-active img')
//         activeImage.src = activeImage.dataset.og;
//       })
//     })
//   })
// })()

const setCheckoutButton = () => {
  const buttons = Array.from(
    document.querySelectorAll('button[name="checkout"]')
  );
  buttons.forEach((b) => {
    b.addEventListener("click", () => {
      createOrder();
    });
  });
};

setTimeout(() => {
  setCheckoutButton();
}, 1000);

// footer accordions
const handleFooterAccordions = (() => {
  const footerAccordionButtons = document.querySelectorAll(
    "#menu-footer-v2 > li > a"
  );

  const handleAccordionClick = (e) => {
    e.preventDefault();
    if (window.innerWidth < 811) {
      const target = e.currentTarget;
      target.classList.toggle("active");
      const collapsible = target.parentElement.querySelector(".sub-menu");
      jQuery(collapsible).slideToggle();
    }
  };

  footerAccordionButtons.forEach((button) =>
    button.addEventListener("click", handleAccordionClick)
  );

  const updateTabIndex = () => {
    if (window.innerWidth < 811) {
      footerAccordionButtons.forEach((button) =>
        button.setAttribute("tabindex", 0)
      );
    } else {
      footerAccordionButtons.forEach((button) =>
        button.setAttribute("tabindex", -1)
      );
    }
  };
  updateTabIndex();
  window.addEventListener(
    "resize",
    debounce(() => updateTabIndex())
  );
})();

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const launchIcon = document.querySelector("#gnj-launch-icon");

    if (launchIcon && !sessionStorage.getItem("gnj_clicked")) {
      launchIcon.click();
      sessionStorage.setItem("gnj_clicked", "true");
      clearInterval(interval); // Stop checking once clicked
    }
  }, 500); // Check every 500ms
});

jQuery(function () {
  var btn = jQuery(".footer-contrast-mode button");
  if (!btn.length) {
    return;
  }
  var high_contrast_mode = false;

  function update() {
    if (high_contrast_mode) {
      btn.text("Disable High Contrast Mode");
      btn.attr("aria-pressed", true);
    } else {
      btn.text("Enable High Contrast Mode");
      btn.attr("aria-pressed", false);
    }
  }

  btn.click(function () {
    high_contrast_mode = !high_contrast_mode;
    update();

    if (high_contrast_mode) {
      document.cookie = "high_contrast=1;path=/;max-age=31536000";
      jQuery("body").addClass("high-contrast");
    } else {
      document.cookie = "high_contrast=0;path=/;max-age=31536000";
      jQuery("body").removeClass("high-contrast");
    }
  });

  if (document.cookie.indexOf("high_contrast=1") > -1) {
    high_contrast_mode = true;
    update();
  }
});

if (document.cookie.indexOf("high_contrast=1") > -1) {
  document.body.className += " high-contrast";
}

window.SLIDECART_UPDATED = function (cart) {
  const cartCounts = document.querySelectorAll(".cart-count span");
  if (cart.item_count > 0) {
    cartCounts.forEach((c) => (c.innerText = cart.item_count));
  }
};


function consent_update() {
  var hasConsent = OnetrustActiveGroups.includes(",2,"); 
  window.BV = window.BV || {};
  window.BV.cookieConsent = window.BV.cookieConsent || {};


  if (window.BV.cookieConsent.setConsent) {
    window.BV.cookieConsent.setConsent({
      "BVBRANDID": hasConsent,
      "BVBRANDSID": hasConsent,
      "bv_metrics": hasConsent
    });
  }
  if (window.crl8 && window.crl8.cookieConsent) {
    window.crl8.cookieConsent.setConsent({
      "crl8.fpcuid": hasConsent
    });
  }
}

window.addEventListener("OneTrustGroupsUpdated", event => {
  consent_update();
});

consent_update();